export const ERRORS = {
  ACCEPT_TERMS_NOT_CHECKED: 'ACCEPT_TERMS_NOT_CHECKED',
  INSUFFICIENT_PASSWORD_STRENGHT: 'INSUFFICIENT_PASSWORD_STRENGHT',
  PASSWORD_CONTAINS_USER_DATA: 'PASSWORD_CONTAINS_USER_DATA',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
};
